import { Router } from '@angular/router';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { EncryptionService } from '@app/services/encyption.service';

export class GoToFilter {
    protected encservice: EncryptionService;
    protected router: Router;
    protected guardService: AuthGuardService;

    private CURRENT_URL: string = '';
    private justeurl: boolean = false;
    constructor(encservice, router, justeurl?) {
        if (justeurl) {
            this.justeurl = true;
        }
        this.encservice = encservice;
        this.router = router;
    }

    goto(cord, reference): void {
        if (cord?.link?.length > 0) {
            this.gotoLink(cord.link);
        } else if (cord?.href?.length > 0) {
            this.gotoLink(cord.href);
        } else if (cord?.inputData?.realparams) {
            this.gotoOffers(cord.inputData?.realparams, reference);
        } else if (cord?.ferienhauser) {
            this.gotoFerienhauser(cord?.ferienhauser, reference);
        } else if (cord?.cruise) {
            this.gotocruise(cord.cruise, reference);
        } else if (cord?.carrent) {
            this.gotocarrent(cord.carrent, reference);
        } else if (cord?.flight) {
            this.gotoflight(cord.flight, reference);
        } else if (cord?.globalcontentid?.length > 0) {
            this.gotocontentbyid(cord.globalcontentid);
        }
    }

    getUrl(): string {
        return this.CURRENT_URL;
    }

    gotocruise(cruise, reference): void {
        cruise.reference = reference;
        this.gotoLink(this.router.createUrlTree(['cruise'], { queryParams: { params: this.encservice.encrypt(cruise) } }).toString());
    }

    gotoOffers(params, reference): void {
        params.reference = reference;
        this.gotoLink(this.router.createUrlTree([this.getPath(params)], { queryParams: { params: this.encservice.encrypt(params) } }).toString());
    }

    gotoFerienhauser(params, reference): void {
        params.reference = reference;
        this.gotoLink(this.router.createUrlTree(['ferienhause'], { queryParams: { params: this.encservice.encrypt(params) } }).toString());
    }

    gotocontentbyid(globalcontentid): void {
        const url = this.router.createUrlTree(['contents', globalcontentid]).toString();
        this.gotoLink(url);
    }

    getPath(params): string {
        // console.log(params)
        if (params.pauschalreiseResult?.type === 1 || params?.hotelCodeList?.length > 0 || params?.giataIdList?.length > 0) {
            return 'offers';
        } else if (params.pauschalreiseResult?.type > 0) {
            return 'hotellist';
        } else {
            return 'topregions';
        }
    }

    gotoLink(path): void {
        this.CURRENT_URL = path;
        if(!this.justeurl) {
            const link = document.createElement('a');
            link.href = path;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    gotocarrent(carrent, reference): void {
        carrent.reference = reference;
        this.gotoLink(this.router.createUrlTree(['carrent'], { queryParams: { params: this.encservice.encrypt(carrent) } }).toString());
    }

    gotoflight(flight, reference): void {
        if (flight?.realparams) {
            flight.realparams.reference = reference;
            this.gotoLink(this.router.createUrlTree(['flugs'], { queryParams: { params: this.encservice.encrypt(flight?.realparams) } }).toString());
        }
    }
}
